/*
 * @Description:
 * @Author: 景 彡
 * @Date: 2022-09-29 10:27:20
 * @LastEditors: 景 彡
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store';
// import "./registerServiceWorker";
import Vant from 'vant';
// import 'ant-design-vue/dist/antd.less';
import '@/assets/default.less';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

import './utils/filter';
// global filter
// 全局自定义组件
import { Ch2ComponsePlugin } from '@/components';
Vue.use(Ch2ComponsePlugin);
import moment from 'moment';
Vue.prototype.$moment = moment;
// init session
import userModule from '@/store/modules/user';

userModule.InitToken();

function getImage(el, binding) {
  const { value: src, modifiers } = binding;
  let request = new XMLHttpRequest();
  let authorization = 'Bearer ' + userModule.token;
  request.responseType = 'blob';
  request.open('get', src, true);
  request.setRequestHeader('Authorization', authorization);
  request.onreadystatechange = () => {
    if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
      el.src = URL.createObjectURL(request.response);
      el.onload = function() {
        if (!modifiers.nopreview) {
          let viewer = new Viewer(el, {
            toolbar: {
              rotateLeft: true,
              rotateRight: true,
              reset: true,
              zoomIn: true,
              zoomOut: true,
            },
          });
        }
      };
    }
  };
  request.send(null);
}

Vue.directive('auth-src', {
  update: getImage,
  inserted: getImage,
});

// router filter
import '@/router/routerPermission';
Vue.config.productionTip = false;
Vue.use(Vant);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
